export default "__VITE_PUBLIC_ASSET__082293c7__"